const EOBDetails = () => {
	return <div className="eob-details-container">EOB Details</div>;
};

export default EOBDetails;
